var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[(! _vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center p-3"},[_c('LeafletComponent',{attrs:{"svgRendered":_vm.svgRendered,"originalColor":_vm.originalColor},on:{"isPanning":(e) => _vm.isPanning = e}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }